import CompanyNewsPage from './CompanyNewsPage';

export default CompanyNewsPage;
